import React from "react";
import "./TokenRenewLogin.scss";
import { Box, Button, TextField } from "@mui/material";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import { useSelector } from "react-redux";
import ErrorNotification from "../ErrorNotification";

const TokenRenewLogin = ({ submitForm, password, setPassword, logout }) => {
  const auth = useSelector((state) => state.auth);

  const passwordKeyDown = (e) => {
    // 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
    console.group("passwordKeyDown");
    if (e.key === "Enter") {
      e.preventDefault();
      const submitEvent = new Event("click", { bubbles: true });
      const login_button = document.getElementById("login_button");
      login_button.dispatchEvent(submitEvent);
    }
    console.groupEnd();
  };

  return (
    <Dialog fullScreen open={true}>
      <Box m={2} align="center">
        <h2 className="sectionTitle center">Username / Password</h2>
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          <Grid item xs={12}>
            <TextField
              key={"user_name"}
              label="UserName"
              variant="outlined"
              fullWidth
              InputProps={{ style: { backgroundColor: "white" } }}
              value={auth.username}
              size="small"
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              key={"password"}
              label="Password"
              variant="outlined"
              fullWidth
              InputProps={{ style: { backgroundColor: "white" } }}
              type="password"
              value={password}
              onChange={(e) => setPassword(e, e.target.value)}
              onKeyDown={(e) => passwordKeyDown(e)}
              size="small"
            />
          </Grid>
          <Grid item xs={12}>
            Please log out if this is not your username.
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={2}
        >
          <Grid item xs={5}>
            <Button
              variant="contained"
              style={{ backgroundColor: "#5499C7" }}
              className="form-input margTop20"
              onClick={logout}
            >
              Logout
              <Link to={`${process.env.PUBLIC_URL}/login`} />
            </Button>
          </Grid>
          <Grid item xs={5}>
            <Button
              id={"login_button"}
              variant="contained"
              color="primary"
              className="form-input margTop20"
              onClick={(e) => submitForm(e, auth.username, password)}
            >
              Log In
            </Button>
          </Grid>
        </Grid>
      </Box>
      <ErrorNotification />
    </Dialog>
  );
};

export default TokenRenewLogin;
